import { getController } from '@/controllers/request';

export default {
  namespaced: true,
  state: {
    content: '',
    isLoading: false
  },
  mutations: {
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    }
  },
  actions: {
    async loadOldPage({ state, commit }, params = null) {
      if (!params) return;
      commit('setLoading', true);

      const resp = await getController({
        params,
        headers: {
          Accept: 'text/html'
        }
      });

      if (typeof resp?.data == 'string') {
        state.content = resp.data;
        commit('setLoading', false);
      }
    }
  }
};
